<template>
  <div>
    <input type="text" class="input-text" placeholder="Имя" v-model="name">
    <input type="text" class="input-text" placeholder="Email или телефон" v-model="contact">
    <vSelect v-model="city" :options="cities" :placeholder="'Выберите свой город'" :clearable="false"/>
    <Error v-if="error" :text="error"/>
    <Button text="Отправить" @action="send" :disabled="name.length < 3 || contact.length < 5 || city == ''"/>
  </div>
</template>

<script>
  import Button from '@/components/Button.vue';
  import Error from '@/components/Error.vue'
  import vSelect from "vue-select";

  export default {
    components: {
      Button,
      Error,
      vSelect
    },
    data() {
      return {
        error: ''
      }
    },
    computed: {
      cities() {
        let cities = this.$store.state.cities;
        return cities.map((element) => {
          return {label: `${element.title}, ${element.titleRegion}`, value: element.id}
        })
      },
      name: {
        set(val) {
          this.$store.state.symptomsContactsInfo.name = val;
        },
        get() {
          return this.$store.state.symptomsContactsInfo.name
        }
      },
      contact: {
        set(val) {
          this.$store.state.symptomsContactsInfo.contact = val;
        },
        get() {
          return this.$store.state.symptomsContactsInfo.contact
        }
      },
      city: {
        set(val) {
          this.$store.state.symptomsContactsInfo.city = val;
        },
        get() {
          return this.$store.state.symptomsContactsInfo.city
        }
      },
    },
    methods: {
      send() {
        const contact = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(this.contact) ||
         /^((8|\+7)[ \- ]?)?(\(?\d{3}\)?[ \- ]?)?[\d\- ]{7,10}$/.test(this.contact);
         if (!contact) {
           this.error = 'Неправильно введен телефон или email';
           setTimeout(() => {
             this.error = '';
           }, 2000);
         } else {
           console.log('sd')
           this.$store.dispatch('newUser', {
             firstname: this.name,
             login: this.contact,
             cityId: this.city.value,
             hasSymptoms: false,
             symptoms: []
           })
         }
      }
    }
  }
</script>